import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select as MUISelect,
} from "@mui/material";
import { Controller } from "react-hook-form";
import RightToLeftLayout from "../RightToLeft";
import classes from "./style.module.scss";

const SelectField = ({
  name,
  control,
  required = false,
  fullWidth = true,
  variant = "outlined",
  label,
  errorObject,
  className = "",
  options,
  checkMarks = false,
  size = "small",
  theme = 1,
  ...rest
}) => {
  return (
    <RightToLeftLayout>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          const currentValue = field.value ?? [];
          const multiCheckMarks = Array.isArray(currentValue) ? currentValue.map(String) : [];

          const handleChange = (e) => {
            field.onChange(e.target.value);
          };

          const renderSelected = (selected) => {
            if (checkMarks && Array.isArray(selected)) {
              const labels = selected.map((val) => {
                const found = options.find((opt) => opt.value === val);
                return found ? found.label : val;
              });
              return labels.join(", ");
            } else {
              const found = options.find((opt) => opt.value === selected);
              return found ? found.label : "";
            }
          };

          return (
            <FormControl
              {...rest}
              size={size}
              required={required}
              fullWidth={fullWidth}
              error={!!error}
              className={className}
            >
              <InputLabel
                shrink={![null, undefined].includes(field.value)}
                sx={{
                  "& .MuiInputLabel-asterisk": {
                    color: rest?.disabled ? "gray" : "red",
                  },
                }}
              >
                {label}
              </InputLabel>

              <MUISelect
                {...field}
                {...rest}
                label={label}
                variant={variant}
                multiple={checkMarks}
                value={checkMarks ? multiCheckMarks : field.value ?? ""}
                onChange={handleChange}
                renderValue={renderSelected}
                className={`${theme === 2 && classes.fieldTheme2}`}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 250,
                      overflowY: "auto",
                    },
                  },
                }}
              >
                {options?.map((option) => (
                  <MenuItem key={option.value} value={option.value} style={{ direction: "rtl" }}>
                    {checkMarks ? (
                      <>
                        <Checkbox checked={multiCheckMarks.includes(String(option.value))} />
                        <ListItemText primary={option.label} style={{ textAlign: "right" }} />
                      </>
                    ) : (
                      option.label
                    )}
                  </MenuItem>
                ))}
              </MUISelect>

              {(error?.message || errorObject?.message) && (
                <FormHelperText>{error?.message || errorObject?.message}</FormHelperText>
              )}
            </FormControl>
          );
        }}
      />
    </RightToLeftLayout>
  );
};

export default SelectField;
